import React, { ReactNode } from 'react';
import { FormikProps } from 'formik';
import { Col, Row } from 'antd';
import * as Yup from 'yup';

import { getFormItemName } from 'utils/fieldArrayUtils';
import { CustomerInfoFormValues } from '../CustomerInfo';
import FormItem from 'components/formik/FormItem';
import Input from 'components/formik/Input';

export interface BillingContactFormValues {
  contactId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
}

export const billingContactsValidationSchema = {
  firstName: Yup.string()
    .trim()
    .max(120, 'First name should be 120 characters maximum'),
  lastName: Yup.string()
    .trim()
    .max(120, 'Last name should be 120 characters maximum'),
  title: Yup.string().trim().max(120, 'Title should be 120 characters maximum'),
  email: Yup.string()
    .email('Email format is invalid')
    .max(120, 'Email should be 120 characters maximum'),
  phoneNumber: Yup.string()
    .trim()
    .nullable()
    .max(120, 'Phone number should be 120 characters maximum'),
};

export const submitBillingContactsValidationSchema = {
  ...billingContactsValidationSchema,
  firstName:
    billingContactsValidationSchema.firstName.required('Field is required'),
  lastName:
    billingContactsValidationSchema.lastName.required('Field is required'),
  email: billingContactsValidationSchema.email.required('Field is required'),
};

type Props = {
  formik: FormikProps<CustomerInfoFormValues>;
  index: number;
  formNamePrefix?: string;
  actionButtons?: ReactNode;
};

export default React.memo((props: Props) => {
  const { index, actionButtons = null, formNamePrefix } = props;

  const firstNameFormItem = getFormItemName({
    name: 'firstName',
    index,
    prefix: formNamePrefix,
  });
  const lasNameFormItem = getFormItemName({
    name: 'lastName',
    index,
    prefix: formNamePrefix,
  });
  const emailFormItem = getFormItemName({
    name: 'email',
    index,
    prefix: formNamePrefix,
  });
  const phoneFormItem = getFormItemName({
    name: 'phoneNumber',
    index,
    prefix: formNamePrefix,
  });

  return (
    <Row gutter={40}>
      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem name={firstNameFormItem} label="A/P first name *">
              <Input
                name={firstNameFormItem}
                placeholder="Enter A/P first name"
              />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem name={lasNameFormItem} label="A/P last name *">
              <Input name={lasNameFormItem} placeholder="Enter A/P last name" />
            </FormItem>
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem name={emailFormItem} label="A/P email *">
              <Input name={emailFormItem} placeholder="Enter A/P email" />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem label="A/P phone number" name={phoneFormItem}>
              <Input name={phoneFormItem} placeholder="Enter phone number" />
            </FormItem>
          </Col>
        </Row>
      </Col>
      {actionButtons && (
        <Col xs={24}>
          <div>{actionButtons}</div>
        </Col>
      )}
    </Row>
  );
});
